<br>
<mat-tab-group  mat-stretch-tabs >
    <mat-tab label="Leaderboard"> <app-leaderboard [playerCount]="playerCount" ></app-leaderboard></mat-tab>
    <mat-tab label="Service Leaderboard" *ngIf="enableServices"> <app-service-leaderboard [playerCount]="playerCount"  ></app-service-leaderboard></mat-tab>
</mat-tab-group>
